import { sp } from "@pnp/sp";

import getCurrentPageData from "./currentpage";
import { webAbsoluteUrl, cleanPrice } from "./utils";
import { configuration } from "./config";

const fakeGetRoomKinds = () =>
  new Promise(resolve =>
    setTimeout(
      () =>
        resolve([
          {
            id: "1",
            title: "Camera matrimoniale superior",
            lowPrice: 100,
            averagePrice: 200,
            highPrice: 300,
            veryHighPrice: 400,
            maxGuests: 2
          },
          {
            id: "2",
            title: "Appartamento del minatore",
            lowPrice: 107,
            averagePrice: 207,
            highPrice: 307,
            veryHighPrice: 407,
            maxGuests: 6
          }
        ]),
      500
    )
  );

const remoteGetRoomKinds = () =>
  getCurrentPageData().then(res =>
    res.Tenuta
      ? sp
          .search({
            Querytext: String.format(
              configuration.rooms.query,
              res.Tenuta.Label,
              webAbsoluteUrl
            ),
            RowLimit: 100,
            EnableInterleaving: true,
            SelectProperties: configuration.rooms.properties,
            TrimDuplicates: false
          })
          .then(r =>
            r.PrimarySearchResults.map(room => ({
              id: room.UniqueId,
              title: room.Title,
              lowPrice: cleanPrice(room.PrezzoOWSCURR) || 0,
              averagePrice: cleanPrice(room.PrezzoMediaOWSCURR) || 0,
              highPrice: cleanPrice(room.PrezzoAltaOWSCURR) || 0,
              veryHighPrice: cleanPrice(room.PrezzoAltissimaOWSCURR) || 0,
              maxGuests: room.OspitiOWSNMBR ? parseInt(room.OspitiOWSNMBR) : 0
            }))
          )
      : null
  );

// const getTenutaRoomsData = () => {
//   return new Promise(resolve =>
//     getCurrentPageData().then(apiData => {
//       if (apiData.Row[0].Tenuta)
//         searchRooms(apiData.Row[0].Tenuta.Label).then(r => {
//           console.log("getTenutaRoomsData", r.PrimarySearchResults);
//           resolve(
//             r.PrimarySearchResults.map(room => ({
//               id: room.UniqueId,
//               title: room.Title,
//               price: cleanPrice(room.PrezzoOWSCURR) || 0,
//               maxGuests: room.OspitiOWSNMBR ? parseInt(room.OspitiOWSNMBR) : 0
//             }))
//           );
//         });
//     })
//   );
// };

export const getRoomKinds = configuration.fakeData
  ? fakeGetRoomKinds
  : remoteGetRoomKinds;
